import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { usePageMeta } from '../hooks/usePageMeta';
import ScrollToTop from '../components/ScrollToTop';
import Reveal from '../components/Reveal';
import Hero from '../components/Hero';

const Imprint = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage].imprint;
  usePageMeta({ title: t.title, description: t.introduction, path: 'imprint' });

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Hero
        gradientClass="hero-legal-imprint"
        title={t.title}
        description={`${t.lastUpdated}: 01.01.2026`}
      />

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-16">
        {/* Introduction */}
        <Reveal>
          <p className="text-lg text-stone-700 mb-12 leading-relaxed">
            {t.introduction}
          </p>
        </Reveal>

        {/* Sections */}
        <div className="space-y-12">
          {/* Responsible */}
          <Reveal as="section" whileHover={{ y: -3 }} className="bg-stone-100 p-8 rounded-sm border border-stone-200">
            <h2 className="font-serif text-2xl font-bold text-stone-900 mb-6">{t.sections.responsible.title}</h2>
            <div className="space-y-3">
              <div><p className="text-stone-700 text-lg font-semibold">{t.sections.responsible.name}</p></div>
              <div><p className="text-stone-700">{t.sections.responsible.address}</p></div>
              <div><p className="text-stone-700">{t.sections.responsible.email}</p></div>
              <div><p className="text-stone-700">{t.sections.responsible.phone}</p></div>
            </div>
          </Reveal>

          {/* EU Dispute Resolution */}
          <Reveal as="section">
            <h2 className="font-serif text-2xl font-bold text-stone-900 mb-4 pb-3 border-b-2 border-amber-600">
              {t.sections.eu.title}
            </h2>
            <p className="text-stone-700 leading-relaxed">{t.sections.eu.content}</p>
          </Reveal>

          {/* Liability */}
          <Reveal as="section">
            <h2 className="font-serif text-2xl font-bold text-stone-900 mb-4 pb-3 border-b-2 border-amber-600">
              {t.sections.liability.title}
            </h2>
            <div className="space-y-4">
              <p className="text-stone-700 leading-relaxed">{t.sections.liability.intro}</p>
              <p className="text-stone-700 leading-relaxed">{t.sections.liability.accuracy}</p>
              <p className="text-stone-700 leading-relaxed">{t.sections.liability.liability_clause}</p>
            </div>
          </Reveal>

          {/* Copyright */}
          <Reveal as="section">
            <h2 className="font-serif text-2xl font-bold text-stone-900 mb-4 pb-3 border-b-2 border-amber-600">
              {t.sections.copyright.title}
            </h2>
            <p className="text-stone-700 leading-relaxed">{t.sections.copyright.content}</p>
          </Reveal>

          {/* Data Privacy */}
          <Reveal as="section">
            <h2 className="font-serif text-2xl font-bold text-stone-900 mb-4 pb-3 border-b-2 border-amber-600">
              {t.sections.dataprivacy.title}
            </h2>
            <p className="text-stone-700 leading-relaxed">{t.sections.dataprivacy.content}</p>
          </Reveal>

          {/* Disclaimer */}
          <Reveal as="section">
            <h2 className="font-serif text-2xl font-bold text-stone-900 mb-4 pb-3 border-b-2 border-amber-600">
              {t.sections.disclaimer.title}
            </h2>
            <p className="text-stone-700 leading-relaxed">{t.sections.disclaimer.content}</p>
          </Reveal>
        </div>

        {/* Footer CTA */}
        <Reveal className="mt-16 p-8 bg-amber-50 border-l-4 border-amber-600 rounded-sm">
          <p className="text-stone-700 text-lg">
            {currentLanguage === 'de'
              ? 'Bei Fragen zum Impressum kontaktieren Sie uns unter info@alitero.eu'
              : currentLanguage === 'en'
              ? 'If you have any questions about this legal notice, please contact us at info@alitero.eu'
              : currentLanguage === 'sv'
              ? 'Om du har några frågor om detta meddelande, kontakta oss på info@alitero.eu'
              : 'Ha kérdése van az impresszummal kapcsolatban, vegye fel velünk a kapcsolatot a info@alitero.eu címen'}
          </p>
        </Reveal>
      </div>
      <ScrollToTop />
    </div>
  );
};

export default Imprint;
